export default "__VITE_ASSET__Ea2CPXPi__"